import React from 'react';
import Svg, { Circle, Line } from 'react-native-svg';

type SearchIconProps = {
  color?: string;
};

const SearchIcon = ({ color = '#6b7280' }: SearchIconProps) => {
  return (
    <Svg width={22} height={22} viewBox="0 0 24 24" fill="none">
      <Circle cx={11} cy={11} r={7} stroke={color} strokeWidth={2} />
      <Line x1={16.5} y1={16.5} x2={21} y2={21} stroke={color} strokeWidth={2} strokeLinecap="round" />
    </Svg>
  );
};

export default SearchIcon;